import moment from 'moment'
import downloadjs from 'downloadjs'
import groupby from 'lodash.groupby'
import { v4 as uuid } from 'uuid'
import {
  fetchWithToken,
} from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const CommandesService = {
    processCommandeNb(commandeNumberLimitSetting, idCommande){ 
      const commandeNumberLimit = parseInt(commandeNumberLimitSetting)
      if(!commandeNumberLimit || commandeNumberLimit === 0){
        return idCommande
      }
      const commandeModulo = idCommande % commandeNumberLimit
      if(commandeModulo === 0){
        return commandeNumberLimit
      }
      return commandeModulo
  },
  getAllowedCommandesCode(clientId) {
    return fetchWithToken(`${config().commandeService}/codes/allowed/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
      .catch(err => new Error('Impossible de récupérer la liste de produits filtrés ', err))
  },
  getShift(commande) {
    // Validation des données d'entrée
    if (!commande || !commande.date || !commande.heure) {
      return Promise.resolve(0)
    }
    
    const startMoment = moment(`${commande.date} ${commande.heure}`, 'YYYY-MM-DD HH:mm')
    const endMoment = moment(`${commande.date} ${commande.heure}`, 'YYYY-MM-DD HH:mm').add(15, 'minutes')
    
    // Vérifier que les dates sont valides
    if (!startMoment.isValid() || !endMoment.isValid()) {
      console.warn('Dates invalides pour getShift:', { date: commande.date, heure: commande.heure })
      return Promise.resolve(0)
    }
    
    const start = startMoment.format('YYYY-MM-DD HH:mm:00')
    const end = endMoment.format('YYYY-MM-DD HH:mm:00')
    const filter = JSON.stringify([{ 'field': 'dateLivraison', 'operator': '>=', 'value': start }, { 'field': 'dateLivraison', 'operator': '<', 'value': end }])
    return fetchWithToken(`${config().syncService}/commandesCommons?filters=${filter}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then(shift => shift.length)
      .catch(err => {
        console.error('Erreur lors de la récupération des créneaux horaires:', err)
        return 0
      })
  },
  getCommandes(date = moment().format('YYYY-MM-DD')) {
    return fetchWithToken(`${config().commandeService}/?date=${date}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .catch(err => new Error('Impossible de récupérer les commandes clients ', err))
  },
  getCustomersList() {
    return fetchWithToken(`${config().syncService}/commandesCommons`, {
      method: 'GET',
    }).then((response) => response.json())
      .then((customers) => customers.map(customer => ({ nom: customer.nom, prenom: customer.prenom, telephone: customer.telephone })))
      .catch(err => new Error('Impossible de récupérer l\'historique des clients ', err))
  },
  getTempsLivraison() {
    return fetchWithToken(`${config().commandeService}/delay`, {
      method: 'GET',
    }).then((response) => response.json())
  },
  getConditionnementVente() {
    return fetchWithToken(`${config().commandeService}/conditionnements`, {
      method: 'GET',
    }).then((response) => response.json())
      .catch(err => new Error('Impossible de récupérer les conditionnements ', err))
  },
  getConditionnementCommande() {
    return fetchWithToken(`${config().commandeService}/conditionnements/commande`, {
      method: 'GET',
    }).then((response) => response.json())
      .catch(err => new Error('Impossible de récupérer les conditionnements des produits ', err))
  },
  getNextCommandeNumber() {
    const filter = JSON.stringify([{ 'field': 'auxiliaire', 'operator': '=', 'value': 9 }])
    return fetchWithToken(`${config().syncService}/commandesCommons?deleted=true&filters=${filter}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then(commandes => Math.max(...commandes.map(c => c.idCommande)))
      .catch(err => new Error('Impossible de récupérer le numéro de commande ', err))
  },

  upsertCommande(commande) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const commandeUuid = uuid()
    if (!commande._id) {
      return this.getNextCommandeNumber()
        .then((lastCommande) => {
          const finalCommande = {
            ...commande,
            _id: commandeUuid,
            idCommande: lastCommande ? lastCommande + 1 : 1,
            commandeUuid,
            lastUpdate,
            deleted: false,
          }
          return fetchWithToken(`${config().syncService}/commandesCommons`, {
            method: 'PUT',
            body: JSON.stringify([finalCommande]),
          }).then((body) => body.json())
            .then(() => ({
              ...finalCommande,
              idCommande: finalCommande.idCommande,
              commande_uuid: finalCommande._id,
              lastUpdate,
            }))
            .catch(err => new Error('Impossible de mettre à jour la commande', err))
        })
    }
    return fetchWithToken(`${config().syncService}/commandesCommons`, {
      method: 'PUT',
      body: JSON.stringify([{ ...commande, lastUpdate }]),
    }).then((body) => body.json())
      .then(() => ({
        ...commande,
        idCommande: commande.idCommande,
        commande_uuid: commande._id,
        lastUpdate,
      }))
      .catch(err => new Error('Impossible de mettre à jour la commande', err))
  },
  putCommandeCode(codeCommande) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const codeCommandeToUpdate = { ...codeCommande, lastUpdate, deleted: false }
    return fetchWithToken(`${config().syncService}/commandesCodes`, {
      method: 'PUT',
      body: JSON.stringify([codeCommandeToUpdate]),
    })
      .then((body) => body.json())
      .catch(err => new Error('Impossible de mettre à jour la préparation du produit de la commande', err))
  },
  deleteCommandeCode(codeCommande) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const codeCommandeToDelete = { ...codeCommande, lastUpdate, deleted: true }
    return fetchWithToken(`${config().syncService}/commandesCodes`, {
      method: 'PUT',
      body: JSON.stringify([codeCommandeToDelete]),
    }).then((body) => body.json())
      .catch(err => new Error('Impossible de supprimer la préparation du produit de la commande', err))
  },

  putCommandePlateau(plateauCommande) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const plateauCommandeToUpdate = { ...plateauCommande, lastUpdate, deleted: false }
    return fetchWithToken(`${config().syncService}/commandesPlateaux`, {
      method: 'PUT',
      body: JSON.stringify([plateauCommandeToUpdate]),
    }).then((body) => body.json())
      .catch(err => new Error('Impossible de mettre à jour le plateau de la commande', err))
  },
  deleteCommandePlateau(plateauCommande) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const plateauCommandeToDelete = { ...plateauCommande, lastUpdate, deleted: true }
    return fetchWithToken(`${config().syncService}/commandesPlateaux`, {
      method: 'PUT',
      body: JSON.stringify([plateauCommandeToDelete]),
    }).then((body) => body.json())
      .catch(err => new Error('Impossible de supprimer le plateau de la commande', err))
  },
  putConditionnementCommande(code) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const conditionnementCommandeToUpdate = {
      ...code, _id: code._id || uuid(), lastUpdate, deleted: false,
    }
    return fetchWithToken(`${config().syncService}/codeConditionnementCommande`, {
      method: 'PUT',
      body: JSON.stringify([conditionnementCommandeToUpdate]),
    }).then((body) => body.json())
      .catch(err => new Error('Impossible de mettre à jour la préparation produit de la commande', err))
  },
  deleteCodeConditionnementCommande(code) {
    const lastUpdate = moment().format('YYYY-MM-DD HH:mm:ss')
    const lastUploaded = moment().format('YYYY-MM-DD HH:mm:ss')
    const codeToDelete = {
      ...code, lastUpdate, lastUploaded, deleted: true,
    }
    return fetchWithToken(`${config().syncService}/codeConditionnementCommande/${code._id}`, {
      method: 'DELETE',
      body: JSON.stringify([codeToDelete]),
    })
      .catch(err => new Error('Impossible de supprimer la préparation produit de la commande', err))
  },
  insertPlateauCommandeSize(plateauxSize) {
    const plateauxSizeWithLastUpdate = plateauxSize.map(plateau => ({ ...plateau, lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss') }))
    return fetchWithToken(`${config().syncService}/plateauSizeCommande`, {
      method: 'PUT',
      body: JSON.stringify(plateauxSizeWithLastUpdate),
    })
      .catch(err => new Error('Impossible de mettre à jour la taille du plateau de la commande', err))
  },
  deletePlateauCommande(plateauxSize) {
    const plateauxSizeWithLastUpdate = plateauxSize.map(plateau => ({ ...plateau, deleted: true, lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss') }))
    return fetchWithToken(`${config().syncService}/plateauSizeCommande`, {
      method: 'PUT',
      body: JSON.stringify(plateauxSizeWithLastUpdate),
    })
      .catch(err => new Error('Impossible de supprimer la taille du plateau de la commande', err))
  },
  loadPlateauSize() {
    return fetchWithToken(`${config().syncService}/plateauSize`, {
      method: 'GET',
    }).then((response) => response.json())
      .catch(err => new Error('Impossible de charger les tailles du plateau de la commande', err))
  },
  getPrinted() {
    return fetchWithToken(`${config().commandeService}/printed`, {
      method: 'GET',
    })
      .then((response) => response.json())
  },
  setPrinted(commandes) {
    return fetchWithToken(`${config().commandeService}/printed`, {
      method: 'POST',
      body: JSON.stringify(commandes),
    })
  },
  getByMonth(date = moment().format('YYYY-MM-DD')) {
    const dateStart = moment(date, 'YYYY-MM-DD').subtract(3, 'months').startOf('month').format('YYYY-MM-DD')
    const dateEnd = moment(date, 'YYYY-MM-DD').add(1, 'month').endOf('month').format('YYYY-MM-DD')
    return fetchWithToken(`${config().commandeService}/calendar/?dateStart=${dateStart}&dateEnd=${dateEnd}`, {
      method: 'GET',
    })
      .then((response) => response.json())
  },
  groupCommandes(commandes) {
    return fetchWithToken(`${config().commandeService}/group`, {
      method: 'POST',
      body: JSON.stringify(commandes),
    }).then((response) => response.json())
      .catch(err => new Error('Impossible de grouper les produits', err))
  },
  downloadPerPage(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/commandes.html`,
      }),
    }).then((response) => response.blob())
      .then((file) => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },

  downloadAll(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/commande.html`,
      }),
    }).then((response) => response.blob())
      .then((file) => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },

  processPlateauSize(commandes, plateauSize, plateauxList) {
    return commandes.map(commande => {
      if (commande.plateauSizeCommande && commande.plateauSizeCommande.length) return commande

      if (commande.plateaux.length === 0) return { ...commande, plateauSizeCommande: [] }
      const totalProductsPlateau = commande.plateaux.reduce((total, current) => {
        const foundPlateau = plateauxList.find(plateau => current.idPlateau === plateau.idPlateau)
        return foundPlateau ? total + (foundPlateau.products.length * current.quantite) : ''
      }, 0)
      const sortedPlateauSize = [...plateauSize].sort((a, b) => a.maxProductNumber - b.maxProductNumber)
      const grouped = groupby(CommandesService.findBestPlateauSize(totalProductsPlateau, sortedPlateauSize), 'nom')

      const plateauxGrouped = Object.getOwnPropertyNames(grouped)
      return { ...commande, plateauSizeCommande: plateauxGrouped.map(plateauName => ({ nom: plateauName, quantite: grouped[plateauName].length, idPlateauSize: grouped[plateauName][0]._id })) }
    })
  },


  findBestPlateauSize(products, plateauxSize, selectedPlateauSize = []) {
    if (!plateauxSize.length) return []

    const bestPlateauSize = plateauxSize.find(plateauSize => products < plateauSize.maxProductNumber)
    if (!bestPlateauSize) {
      const largePlateauSize = plateauxSize[plateauxSize.length - 1]
      return CommandesService.findBestPlateauSize(products - largePlateauSize.maxProductNumber, plateauxSize, [...selectedPlateauSize, largePlateauSize])
    }
    return [...selectedPlateauSize, bestPlateauSize]
  },


}
